<template>
  <div class="graph-container">
    <header><slot name="title"></slot></header>
    <div class="d-flex justify-content-between align-items-center">
      <div ref="graph" class="graph"></div>
      <div class="w-100 px-4">
        <ul>
          <li v-for="(record, index) in data" :key="index" class="label">
            <slot name="label" v-bind="{ colors, index, othersData, record }">
              <span class="d-flex align-items-center"><span class="label-color mr-2" :style="`background-color: ${colors[index]};`"></span> {{ record[fields.category] }}</span>
              <div class="label-value">{{ record[fields.value] }}</div>
            </slot>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import BaseGraph from "./_BaseGraph";

am4core.useTheme(am4themes_animated);

export default {
  extends: BaseGraph,
  props: {
    tooltip: {
      type: Function,
      default: () => {}
    },
    type: {
      type: String,
      required: false
    }
  },
  computed: {
    dataSortedByCustomPropsType(){
      if(!!this.type){
        return this.data.sort((a, b) => a[this.type] - b[this.type] )
      }
      return this.data
    }
  },
  methods: {
    buildGraph () {
      if (this.data) {
        let chart = am4core.create(this.$refs.graph, am4charts.RadarChart);

        am4core.options.commercialLicense = true;
        chart.data = this.data.slice().reverse();

        // Make chart not full circle
        // chart.startAngle = -90;
        chart.endAngle = 260;
        // chart.innerRadius = am4core.percent(20);

        // Set number format
        chart.numberFormatter.numberFormat = this.numberFormat

        // Create axes
        let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = this.fields.category;
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.grid.template.strokeOpacity = 0;
        categoryAxis.renderer.labels.template.disabled = true;
        categoryAxis.renderer.minGridDistance = 10;

        let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.min = 0;
        valueAxis.max = 100;
        valueAxis.strictMinMax = true;

        // Create series
        let series1 = chart.series.push(new am4charts.RadarColumnSeries());
        series1.dataFields.valueX = this.fields.max;
        series1.dataFields.categoryY = this.fields.category;
        series1.clustered = false;
        series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
        series1.columns.template.fillOpacity = 0.08;
        series1.columns.template.cornerRadiusTopLeft = 20;
        series1.columns.template.strokeWidth = 0;
        series1.columns.template.radarColumn.cornerRadius = 20;
        series1.xAxis.hidden = true

        let series2 = chart.series.push(new am4charts.RadarColumnSeries());
        series2.dataFields.valueX = this.fields.value;
        series2.dataFields.categoryY = this.fields.category;
        series2.clustered = false;
        series2.columns.template.strokeWidth = 0;
        series2.columns.template.tooltipText = `{${this.fields.category}}: [bold]{${this.fields.value}.formatNumber('#.0')}%[/]`;
        series2.columns.template.radarColumn.cornerRadius = 20;

        if (this.tooltip) {
          series2.columns.template.adapter.add('tooltipHTML', (text, target) => {
            const data = target.tooltipDataItem
            return this.tooltip(data)
          })
        }

        series2.columns.template.adapter.add("fill", (fill, target) => {
          return this.colors.slice().reverse()[target.dataItem.index];
        });

        // Add cursor
        chart.cursor = new am4charts.RadarCursor();

        this.chart = chart
      }
    }
  }
};
</script>
<style scoped>
.graph {
  width: 300px;
}
.label {
  display: flex;
  align-items: center;
  font-size: .75rem;
  width: 100%;
}
.label-color {
  display: inline-block;
  height: .75rem;
  width: .75rem;
  border-radius: 3px;
}
.label-value {
  margin-left: auto;
}
</style>
